            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >
        
                  <b-form  inline style="margin-bottom:15px" novalidate>
                    <b-row style="width:100%">                      
                      <b-col md="12">
                        <h5 class="title-form">Datos Básicos</h5>
                        <b-row  class="row-inputs">
                          <sw-inputs
                            inputTabla="datos_afiliado"
                            inputCampo="id_list_documento"
                            >
                          </sw-inputs> 
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="documento"
                            >
                          </sw-inputs>                   
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nacimiento"
                              :lg='6'
                              :md='6'
                            >
                          </sw-inputs>                          
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nombre1"
                            >       
                          </sw-inputs>                      
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nombre2"
                            >
                          </sw-inputs>                     
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="apellido1"
                            >
                          </sw-inputs>                       
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="apellido2"
                            >
                          </sw-inputs>                     
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="direccion"
                              :lg="6"
                            >
                          </sw-inputs>                       
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="telefonos"
                            >
                          </sw-inputs>                      
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="ciudad"
                            >
                          </sw-inputs>                  
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="email"
                              :lg="6"
                            >
                          </sw-inputs>    
                        </b-row>
                      </b-col>   
                      <b-col md="12">
                        <h5 class="title-form">Datos afiliación</h5>
                        <b-row class="row-inputs"> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_razon">
                            </sw-inputs>               
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="ingreso"
                              @input="changeIngreso"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="salario"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="cargo"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_asesor"                              
                              :lg="3">
                            </sw-inputs>   
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_contacto"                              
                              :lg="3">
                            </sw-inputs>   
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="exonerado"
                              :lg="6">
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_list_tipo"
                              :md="12"
                              :lg="6">
                            </sw-inputs>
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_list_subtipo"
                              :md="12"
                              :lg="6">
                            </sw-inputs>
                        </b-row>
                      </b-col> 
                      <b-col  md="12">
                          <h5 class="title-form">Servicios</h5>
                          <b-row>
                            <sw-tablemultiple
                              style="padding:0"
                              getTable="multiple_servicios"
                              :views="[
                                { th:'Select.', td: 'check'},
                                { th:'Servicio', td: 'name'},
                                { th:'Entidad', td: 'id_list'},
                                { th:'Afiliación', td: 'afiliacion'},
                                { th:'Valor', td: 'valor'},
                              ]"
                              >
                            </sw-tablemultiple>
                              <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="observacion"
                                :md="12"
                                :lg="12"
                                >
                              </sw-inputs> 
                          </b-row>
                        </b-col>                                                           
                    </b-row>                  
                  </b-form> 
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
              <b-row style="width:100%">
                <b-col :md="12" :lg="12" v-if="errorsAportes!=='' && errorsAportes!==null">
                    <p  class="text-danger">* {{errorsAportes}}</p>  
                </b-col>
                <b-col>     
                  <sw-saveform
                    :index="dataIndex[namePath]"
                    nameBtn=""
                    :invalid="invalidNovedad(invalid) || invalid"
                    @save="saveFicha"
                    >
                  </sw-saveform>
                </b-col>
              </b-row>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import saveMixins  from '@/mixings/save.js'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  mixins: [saveMixins],
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform, 
    SwTablemultiple     
  },
  props: {
  },
  data()
  {
    return {
      createdCycle: false,
      errorsAportes: null,
      ultimoDocumento: null
    }
  },
  destroyed()
  {    
		this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
  },
  async created(){
		await this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required|minIngreso'})
    if(this.dataIndex[this.namePath]!==false)
    {      	
      this.ultimoDocumento=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.documento
      const await1 = this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
      const await2 =  this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      const await3 =  this.updateDataForm({state: 'servicios_activos', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos})
      const await4 =  this.updateDataForm({state: 'servicios_nuevos', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_nuevos})
      const await5 =  this.updateDataForm({state: 'afiliacion_registro', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro})
      const await6 =  this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})

      await Promise.all([await1,await2,await3,await4,await5,await5])

      
      await this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
      await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })

			for(var i=0;i<this.dataForm[this.namePath].servicios_nuevos.length; i++)
			{					
				let control = this.dataMultiple[this.namePath].multiple_servicios.findIndex( items => items.name===this.dataForm[this.namePath].servicios_nuevos[i].name) 
				if(control>=0)
				{
					this.$set(this.dataMultiple[this.namePath].multiple_servicios,control,this.dataForm[this.namePath].servicios_nuevos[i])
				}
			}	
			for(var i=0;i<this.dataForm[this.namePath].servicios_activos.length; i++)
			{					
				let control = this.dataMultiple[this.namePath].multiple_servicios.findIndex( items => items.name===this.dataForm[this.namePath].servicios_activos[i].name) 
				if(control>=0)
				{
					this.$set(this.dataMultiple[this.namePath].multiple_servicios,control,this.dataForm[this.namePath].servicios_activos[i])
				}
			}	
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  computed: { 
  },
  methods: {
		invalidNovedad(invalid)
		{	
			try {
				if(invalid)
				{
					this.errorsAportes='Los campos en rojo son obligatorios.'
					return true
				}
					
				let ninguno= ''
				for(let i=0;i<this.lists.datos_afiliado.length;i++)
				{
					if(this.lists.datos_afiliado[i].documento.toString()===this.dataForm[this.namePath].datos_afiliado.documento.toString() && this.lists.datos_afiliado[i].id_list_estado===1 && this.ultimoDocumento!==this.dataForm[this.namePath].datos_afiliado.documento)
					{			
						ninguno=ninguno+' El documento '+this.dataForm[this.namePath].datos_afiliado.documento+' pertenece al afiliado '+this.dataForm[this.namePath].datos_afiliado.name+'.'	
						i=10000							
					}   
				}
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}	

		
				let fechaHoy=this.fecha().fecha.minHoy
				let mesActual=parseInt(moment(fechaHoy).format('MM'))
				let anoActual=parseInt(moment(fechaHoy).format('YYYY'))


				let mesIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
				let anoIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY'))
				

				if(mesActual!=mesIngreso || anoActual!=anoIngreso)
				{
					this.errorsAportes='El inicio de labores es direfente al mes actual'
					return false
				}
				
				this.errorsAportes=null
				return false
			}catch(e)
			{
				console.log(e)
			}
    },
    changeIngreso()
		{
			let dias= moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD')
			if(dias>30)
			{
				dias=30
			}
			dias=31-dias
			this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			this.updateDataForm({state: 'info_afiliacion/mes_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes})
      this.updateDataForm({state: 'info_afiliacion/ano_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano})
      
			this.updateDataForm({state: 'servicios_activos/0/ano_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano})
			this.updateDataForm({state: 'servicios_activos/0/mes_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes})
		},
    async saveFicha(event)
    {
      try {
        if(this.dataForm[this.namePath].servicios_nuevos.length>0 || this.dataForm[this.namePath].servicios_activos.length>0)
        {
          await this.updateDataPost({
            data: {
              data: [{servicios_nuevos: this.dataForm[this.namePath].servicios_nuevos,servicios_activos: this.dataForm[this.namePath].servicios_activos}],
              tablaDelete: ['servicios_nuevos','servicios_activos'],
              tablaAuditar: true,
              notaDelete: null,
              tablaPost: [],
              route: 'save_all'
            }
          })
          await this.save(false,true)
        }


        this.$emit('save',{save:event.save, ftn: 'editarFichaFtn' })

      } catch(e)
      {

      }
    }
  }
}
</script>
<style>
</style>